export default __webpack_public_path__ + "static/histogram-with-specified-bins-26c86f0f6f5348a7d3b5c4ed7298af51.png";